<script>
  import { format } from 'svelte-i18n';

  import { AUDIT_HISTORY_ACTIONS, AUDIT_HISTORY_MESSAGES, AUDIT_HISTORY_TYPES } from '@client/enums';

  export let row = {};

  let value = '';

  $: note = row.note;
  $: type = row.type;
  $: action = row.action;
  $: if (note) {
    if (type === AUDIT_HISTORY_TYPES.documents.id || type === AUDIT_HISTORY_TYPES.images.id) {
      value = note.item.filename;
    }

    if (type === AUDIT_HISTORY_TYPES.sendergroups.id) {
      value = note?.item?.groupname;
    }

    if (type === AUDIT_HISTORY_TYPES.plugins.id) {
      value = note?.item?.provider;
    }

    if (
      type === AUDIT_HISTORY_TYPES.ads.id ||
      type === AUDIT_HISTORY_TYPES.bizcards.id ||
      type === AUDIT_HISTORY_TYPES.tagblocks.id ||
      type === AUDIT_HISTORY_TYPES.surveys.id
    ) {
      value = note?.item?.rulename;
    }

    if (type === AUDIT_HISTORY_TYPES.signatures.id || type === AUDIT_HISTORY_TYPES.bizcardroutes.id) {
      value = note?.item?.blockname;
    }

    if (type === AUDIT_HISTORY_TYPES.csv.id) {
      value = note?.sigdata?.data.length;
    }

    if (type === AUDIT_HISTORY_TYPES.domain.id) {
      value = row?.domainname;
    }

    if (type === AUDIT_HISTORY_TYPES.manual.id) {
      if (
        action === AUDIT_HISTORY_ACTIONS.syncsalesforceusers.id ||
        action === AUDIT_HISTORY_ACTIONS.syncbamboohrusers.id ||
        action === AUDIT_HISTORY_ACTIONS.syncfrontappusers.id ||
        action === AUDIT_HISTORY_ACTIONS.syncmangoappsusers.id ||
        action === AUDIT_HISTORY_ACTIONS.synccalendlyusers.id ||
        action === AUDIT_HISTORY_ACTIONS.synccsvusers.id ||
        action === AUDIT_HISTORY_ACTIONS.synco365groups.id ||
        action === AUDIT_HISTORY_ACTIONS.synco365users.id ||
        action === AUDIT_HISTORY_ACTIONS.syncgappsgroups.id ||
        action === AUDIT_HISTORY_ACTIONS.syncgappsorgs.id ||
        action === AUDIT_HISTORY_ACTIONS.syncgappsusers.id
      ) {
        value = note?.count;
      }

      if (type === AUDIT_HISTORY_TYPES.manual.id && action === AUDIT_HISTORY_ACTIONS.login.id) {
        value = note?.provider;
      }

      if (action === AUDIT_HISTORY_ACTIONS.updateuser.id) {
        const kinds = [];
        if (note?.data?.params?.length) kinds.push($format('label.AUDIT_KIND_FIELDS'));
        if (note?.data?.roles) kinds.push($format('label.AUDIT_KIND_ROLES'));
        if (note?.data?.usersettings) kinds.push($format('label.AUDIT_KIND_SETTINGS'));
        value = kinds.length ? kinds.join(', ') : note?.data?.updateType;
      }

      if (action === AUDIT_HISTORY_ACTIONS.editgoogle.id) {
        value = note?.username;
      }
    }

    if (type === AUDIT_HISTORY_TYPES.outlookaddin.id) {
      if (action === AUDIT_HISTORY_ACTIONS.updateuser.id) {
        const kinds = [];
        if (note?.data?.params?.length) kinds.push($format('label.AUDIT_KIND_FIELDS'));
        if (note?.data?.roles) kinds.push($format('label.AUDIT_KIND_ROLES'));
        if (note?.data?.usersettings) kinds.push($format('label.AUDIT_KIND_SETTINGS'));
        value = kinds.length ? kinds.join(', ') : note?.data?.updateType;
      }
    }

    if (type === AUDIT_HISTORY_TYPES.user.id && action === AUDIT_HISTORY_ACTIONS.custompurge.id) {
      value = note?.count;
    }
  }

  $: messageKey = AUDIT_HISTORY_MESSAGES[type];
  $: message = (messageKey && messageKey[action]) || '';
</script>

{#if note}
  {#if AUDIT_HISTORY_MESSAGES[type]}
    <div class="notes">
      <span>{@html $format(message, { values: { value } })}</span>
    </div>
  {/if}
{:else if action === AUDIT_HISTORY_ACTIONS.login.id}
  {@html $format(AUDIT_HISTORY_MESSAGES[type][action])}
{:else}
  {$format('label.NO_INFORMATION_AVAILABLE')}
{/if}

<style lang="scss">
  .notes {
    align-items: center;
    display: flex;

    span {
      margin-right: var(--margin-base);
    }
  }
</style>
